// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".inputOtherText{margin-top:18px}.errorHeight{height:35px}.w100{width:100%}.helpInputs{margin:0 auto;max-width:400px}.marginBottom{margin-top:20px}.text-right{text-align:right}.closeBtn{cursor:pointer;font-size:22px;position:absolute;right:0;top:-10px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
